<template>
  <div id="Accounts">
    <loading v-if="loadingRender"></loading>
    <panel class="no-print" Title="لیست حساب ها" Des="از طریق این فرم می توانید لیست حساب های خود را مشاهده کنید و عملیات های گردش و واریز وجه انجام  دهید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>

    <div class="row text-right no-print">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-dark active border-none" style="cursor: pointer">
                <input @click="ShowCard(true)" type="radio" name="options" id="option1" autocomplete="off" />
                <i class="fas fa-columns"></i> ستونی
              </label>
              <label class="btn btn-dark border-none" style="cursor: pointer"> <input @click="ShowCard(false)" type="radio" name="options" id="option2" autocomplete="off" checked /><i class="fas fa-list-alt"></i> ردیفی </label>
            </div>
            <ul class="nav nav-tabs mt-3 card-header-tabs" id="myTab" role="tablist" dir="rtl">
              <li class="nav-item">
                <a class="nav-link active text-dark" id="Detail-tab" data-toggle="tab" href="#Detailtab" role="tab" aria-controls="Detailtab" aria-selected="true">حساب های خودم</a>
              </li>
              <li class="nav-item" v-if="$session.get('CustCode') == 801">
                <a class="nav-link text-dark" id="Logo-tab" data-toggle="tab" href="#Logotab" role="tab" aria-controls="Settingtab" aria-selected="true">حساب های وابسته</a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content text-right p-3" id="Controler">
              <div class="tab-pane fade show active" id="Detailtab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false"><i class="fas fa-filter"></i> فیلتر حساب ها</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(false)
                              $ResetTimer()
                            "
                            >حساب های دارای مانده
                            <i v-if="selectedBedehi && selectedAllBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(true)
                              $ResetTimer()
                            "
                            >همه حساب ها
                            <i v-if="selectedAllBedehi && selectedBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="CardItem && CardItem.length > 0 && IsShowCard == true" class="row">
                    <div class="col-md-4 h-100" style="height: 100% !important" v-for="(item, index) in CardItem" :key="index">
                      <div class="card Netpa-Shadow border-0 mb-3 costom-card" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                            v-if="item.isTurnover"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a v-if="$session.get('CustCode') != 868" data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetail(index)" title="جزئیات حساب"><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span></a>
                            <a v-else data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetail(index)" title="جزئیات حساب" class="Pointer mr-2 badge badge-info text-light font-weight-normal px-2 py-1">جزئیات حساب</a>
                            <hr />
                          </div>
                          <div class="col-lg-7 col-md-12 col-12 text-right">
                            <div class="row">
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold no-wrap"> نوع حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold text-dark fl"> {{ item.desNoe }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold no-wrap"> شماره حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span dir="rtl" class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblDate" class="text-right font-weight-bold no-wrap"> افتتاح حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.tarix }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold no-wrap"> شناسه واریز : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-12 col-12 text-center">
                            <div class="">
                              <p class="text-center m-0">موجودی</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.mande.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                              <p v-if="$session.get('CustCode') != 868"  class="text-center m-0">قابل برداشت</p>
                              <small v-if="$session.get('CustCode') != 868" class="card-text">{{ $Comma3ragham(Number(item.ghabelBardasht.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                            </div>
                          </div>
                          <div class="col-12"></div>
                          <div class="col-12 text-center" v-if="item.spName != null && item.spName != ''">
                            <hr />
                            {{ GetAtach(item) }}
                            <div class="">
                              <label>
                                امتیاز شما [ <b class="text-danger">{{ item.emtiazXas }}</b> ] می باشد
                                <small
                                  class="badge badge-secondary text-light font-weight-normal px-3 mr-2 Pointer"
                                  id="ZamenModal"
                                  data-toggle="modal"
                                  data-target="#Modal-light"
                                  @click="
                                    GetAtach(item)
                                    AtachVam = true
                                  "
                                  >جزئیــات امتیازات</small
                                ></label
                              >
                            </div>
                            <div class="">
                              <label v-if="item.rankNumber!=0"> شما نفر [ </label><span  v-if="item.rankNumber!=0" class="font-weight-bold text-danger"> {{ item.rankNumber }} </span><label v-if="item.rankNumber!=0"> ] بر حسب امتیاز مکتسبه می باشید</label>
                              <div v-if="item.rankNumber==0" class="d-block text-warning">( به دلیل داشتن بدهی وام مسکن امتیازی برای شما محاسبه نمی شود )</div>
                            </div>
                          </div>
                          <div class="col-12 text-center my-2" v-if="CheckIsSaham(item) == true">
                            <hr />
                            امتیاز وام تعاونی شما :[ <span class="text-danger">{{ item.emtiazXas2 == null ? 0 : item.emtiazXas2 }}</span> ]
                            <div class="">
                              <label v-if="item.rankNumber2!=0 && item.rankNumber2!=null"> شما نفر [ </label><span  v-if="item.rankNumber2!=0 && item.rankNumber2!=null" class="font-weight-bold text-danger"> {{ item.rankNumber2==null?0:item.rankNumber2 }} </span><label v-if="item.rankNumber2!=0 && item.rankNumber2!=null"> ] بر حسب امتیاز مکتسبه می باشید</label>
                              <div v-if="item.rankNumber2==0 || item.rankNumber2==null" class="d-block text-warning">( به دلیل داشتن بدهی وام تعاونی امتیازی برای شما محاسبه نمی شود )</div>
                            </div>
                            <span class="Pointer btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap mt-2" @click="ShowBargeSaham(item)">نمایش برگه سهام</span>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-xl-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment && item.tblSarfaslTypeId != 6">
                            <a type="button"  class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">واریز</a>
                          </div>
                          <div class="col-xl-4 col-12">
                            <button
                              v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && item.isDebtor==true"
                              type="button"
                              class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                              :disabled="item.ghabelBardasht <= 0"
                              :class="item.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                              @click="debtor(item)"
                              style="font-size: 0.79rem !important"
                            >
                              برداشت
                            </button>
                            <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                          </div>
                          <div class="col-xl-4 col-12">
                            <router-link
                            v-if="item.isTurnover==true"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows" :columns="columns" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="Emtiaz" slot-scope="props" v-if="props.row.spName != null && props.row.spName != ''">
                          {{ props.row.emtiazXas }}
                        </template>
                        <template slot="Detail" slot-scope="props">
                          <a data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetail(props.row.vbt_id - 1)" class="btn btn-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer">جزئیــات بیشتر</a>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <div class="col-xl-4 col-12" v-if="props.row.isPayment">
                              <a v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu" @click="Deposit(props.row)" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer">پرداخت</a>
                            </div>
                            <div class="col-xl-4 col-12">
                              <router-link
                              v-if="props.row.isTurnover==true"
                                title="گردش"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                    wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                            <div class="col-xl-4 col-12">
                              <button
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && props.row.isDebtor==true"
                                type="button"
                                class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                                :disabled="props.row.ghabelBardasht <= 0"
                                :class="props.row.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                                @click="debtor(props.row.id)"
                                style="font-size: 0.79rem !important"
                              >
                                برداشت
                              </button>
                              <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xl-12 col-12" v-if="CheckIsSaham(props.row) == true">
                              امتیاز وام تعاونی شما :[ <span class="text-danger">{{ props.row.emtiazXas2 == null ? 0 : props.row.emtiazXas2 }}</span> ]
                              <span class="Pointer btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap" @click="ShowBargeSaham(props.row)">نمایش برگه سهام</span>
                            </div>
                            <div class="col-xl-12 col-12" v-if="props.row.spName != null && props.row.spName != ''">
                              <span class="Pointer btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap" data-toggle="modal" data-target="#Modal-light" @click="GetAtach(props.row)">جزئیات امتیازات</span>
                            </div>
                          </div>
                        </template>

                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="Logotab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div v-if="CardItemTaahodatSahebHesab.length > 0" class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-expanded="false"><i class="fas fa-filter"></i>حساب های وابسته</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            v-for="item in groupBy"
                            :key="item.Id"
                            :id="item.wwwtblAzaId"
                            @click="
                              GetSahebHesab(item.wwwtblAzaId, false)
                              $ResetTimer()
                            "
                          >
                            {{ item.nameFamily }}</a
                          >
                          <hr />
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetSahebHesab(0, true)
                              $ResetTimer()
                            "
                            >همه حساب های وابسته
                            <i class="fas fa-check text-success"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="col-12">
                      <div class="alert alert-warning w-100 text-center">در حال حاضر حساب های وابسته شما صفر میباشد</div>
                    </div>
                  </div>
                  <div v-if="FilterCardItemTaahodatSahebHesab && FilterCardItemTaahodatSahebHesab.length > 0 && IsTaahodatSahebHesab == true && IsShowCard == true" class="row">
                    <div class="col-md-4" v-for="(item, index) in FilterCardItemTaahodatSahebHesab" :key="index">
                      <div class="card border-0 mb-3 costom-card-sahebanhesab" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                            v-if="item.isTurnover==true"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>

                            <a data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetailSahebanHesab(index)" title="جزئیات حساب"><i class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></i></a>
                            <small class="text-dark float-left ml-3"
                              ><span class="fas fa-user text-success" style="font-size: 15px"></span>
                              {{ item.nameFamily }}
                            </small>
                            <hr />
                          </div>
                          <div class="col-lg-7 col-md-12 col-12 text-right">
                            <div class="row">
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold no-wrap"> نوع حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.desNoe }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold no-wrap"> شماره حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span dir="rtl" class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblDate" class="text-right font-weight-bold no-wrap"> افتتاح حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.tarix }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold no-wrap"> شناسه واریز : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-12 col-12 text-center">
                            <div class="">
                              <p class="text-center m-0">موجودی</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.mande.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                              <p class="text-center m-0">قابل برداشت</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.ghabelBardasht.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment && item.tblSarfaslTypeId != 6">
                            <a type="button" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">واریز</a>
                          </div>
                          <div class="col-md-4 col-12">
                            <button
                              v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && item.Debtor==true"
                              type="button"
                              class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                              :disabled="item.ghabelBardasht <= 0"
                              :class="item.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                              @click="debtor(item)"
                              style="font-size: 0.79rem !important"
                            >
                              برداشت
                            </button>
                            <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                            v-if="item.isTurnover==true"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows2" :columns="columns2" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <div class="col-xl-4 col-12" v-if="props.row.isPayment">
                              <a v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu" @click="Deposit(props.row)" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer">پرداخت</a>
                            </div>
                            <div class="col-xl-4 col-12">
                              <router-link
                              v-if="props.row.isTurnover==true"
                                title="گردش"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                    wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                            <div class="col-xl-4 col-12">
                              <button
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && props.row.isDebtor==true"
                                type="button"
                                class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                                :disabled="props.row.ghabelBardasht <= 0"
                                :class="props.row.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                                @click="debtor(props.row.id)"
                                style="font-size: 0.79rem !important"
                              >
                                برداشت
                              </button>
                              <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                            </div>
                          </div>
                        </template>
                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <!-- <debtor v-if="AtachVam==false && $store.state.renderComponent" :TaahodatId="taahodatId"></debtor> -->
        <div class="container-fluid text-center" dir="rtl">
          <div class="row">
            <div class="col-12 alert bg-dark text-light" style="font-size: 15px !important">جدول امتیازات وام شما به صورت زیر می باشد</div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" style="width: 60% !important">عنوان</th>
                  <th scope="col" style="width: 20% !important">امتیاز</th>
                  <th scope="col" style="width: 20% !important">امتیاز مکتسبه</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in GridDataAtachVam" :key="index" :class="item.Base == null ? 'bg-gray' : ''">
                  <td>{{ item.Onvan }}</td>
                  <td>{{ item.Base != null ? item.Base : '' }}</td>
                  <td :class="item.Emtiaz > 0 && item.Emtiaz != null ? 'font-weight-bold' : ''">{{ item.Base != null ? item.Emtiaz : '' }}</td>
                </tr>
                <tr>
                  <td colspan="2" class="bg-dark text-light" style="width: 80% !important">جمع امتیازات </td>
                  <td class="font-weight-bold text-danger" style="width: 20% !important">{{ CalcEmtiazXasForTable(GridDataAtachVam) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-slot:HeaderModalInfo>
        <span>
          <i class="fas fa-info-circle text-dark mx-2" style="font-size: 16 !important"></i>
          <span style="font-size: 16 !important" class="text-light font-weight-bold">جزئیات حساب</span></span
        >
      </template>
      <template v-slot:ContentModalMobile>
        <div class="container-fluid">
          <div v-if="detailInModal != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModal].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع حساب: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2"></div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="row text-center pr-3">
              <div class="col-12 text-center" >
                {{ GetAtach(CardItem[detailInModal]) }}
                <div class="text-center">
                  <i class="fas fa-square ml-2 text-info"></i>
                  <span style="font-size: 18px !important" v-if="$session.get('CustCode') == 868 && CardItem[detailInModal].spName!= null && CardItem[detailInModal].spName!= ''">
                    امتیاز وام مسکن شما [ <b class="text-warning">{{ CardItem[detailInModal].emtiazXas }}</b>] می باشد
                  </span>
                  <span style="font-size: 18px !important" v-if="$session.get('CustCode') == 868 && CheckIsSaham(CardItem[detailInModal])">
                    امتیاز وام تعاونی شما [ <b class="text-warning">{{ CardItem[detailInModal].emtiazXas }}</b>] می باشد
                  </span>
                </div>
              </div>
            </div>

            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز حساب:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
          <div v-if="detailInModalSahebHesab != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModalSahebHesab].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع حساب: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز حساب:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from '../Tools/ModalCustom.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import Debtor from './Debtor.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'

export default {
  data() {
    return {
      logo: {},
      emza1: {},
      emza2: {},
      GridDataAtachVam: [],
      AtachVam: false,
      loadingRender: false,
      CardItem: null,
      CardItemTaahodatSahebHesab: 0,
      FilterCardItemTaahodatSahebHesab: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      taahodatId: 0,
      detailInModal: null,
      detailInModalSahebHesab: null,
      selectedBedehi: true,
      selectedAllBedehi: false,
      IsTaahodatSahebHesab: false,
      IsShowCard: true,
      groupBy: null,
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'نوع',
          name: 'desNoe',
        },
        {
          label: 'شماره',
          name: 'vCode',
        },
        {
          label: 'افتتاح حساب',
          name: 'tarix',
        },
        {
          label: 'شناسه واریز ',
          name: 'shenaseVariz',
        },
        {
          label: 'موجودی',
          name: 'NewMande',
        },
        {
          label: 'قابل برداشت',
          name: 'NewghabelBardasht',
          visibility: this.$session.get('CustCode') == 868 ? false :true,
        },
        {
          label: 'جزئیات',
          name: 'Detail',
          visibility: true,
        },
        {
          label: 'امتیاز شما',
          name: 'Emtiaz',
          visibility: true,
        },
        {
          label: 'عملیات ها',
          name: 'id',
          slot_name: 'action-slot',
          sort: false,
        },
      ],
      rows2: [],
      columns2: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'نوع',
          name: 'desNoe',
        },
        {
          label: 'شماره',
          name: 'vCode',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'افتتاح حساب',
          name: 'tarix',
        },
        {
          label: 'شناسه واریز ',
          name: 'shenaseVariz',
        },
        {
          label: 'موجودی',
          name: 'NewMande',
        },
        {
          label: 'قابل برداشت',
          name: 'NewghabelBardasht',
        },
        {
          label: 'عملیات ها',
          name: 'id',
          slot_name: 'action-slot',
          sort: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped  ',
      },
      DataAxiosSaham: {},
    }
  },
  components: {
    Panel,
    ModalCustom,
    Debtor,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    this.GetItemCard(true)
    var a = document.getElementById('dropdownMenuButton')
    a.click()
    this.GetItemCardTaahodatSahebHesab()
    this.getSahamsettings()
  },
  methods: {
    GetSahebHesab(id, IsAll) {
      let info
      let list = []
      if (IsAll) {
        this.IsTaahodatSahebHesab = true
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index]
          info['NewMande'] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          info['NewghabelBardasht'] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          list.push(info)
        }
        this.rows2 = this.$FormatMablaghGrid(list)
      } else {
        this.IsTaahodatSahebHesab = true
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab.filter((x) => x.wwwtblAzaId == id)
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index]
          info['NewMande'] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          info['NewghabelBardasht'] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          list.push(info)
        }
        this.rows2 = this.$FormatMablaghGrid(list)
      }
    },
    ShowCard(status) {
      this.IsShowCard = status
    },
    GetItemCard(IsAll) {
      let info
      let list = []
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (IsAll) {
          this.CardItem = data.filter((x) => x.tblSarfaslTypeId != 6)
          this.selectedBedehi = false
          this.selectedAllBedehi = true

          for (let index = 0; index < data.length; index++) {
            info = data[index]
            info['NewMande'] = data[index].mande + data[index].sumMabTaeedNaShode
            info['NewghabelBardasht'] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode
            list.push(info)
          }
          this.rows = this.$FormatMablaghGrid(this.CardItem)
        } else {
          this.CardItem = data.filter((x) => x.mande > 0)
          this.selectedBedehi = true
          this.selectedAllBedehi = false

          for (let index = 0; index < data.length; index++) {
            info = data[index]
            info['NewMande'] = data[index].mande + data[index].sumMabTaeedNaShode
            info['NewghabelBardasht'] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode
            list.push(info)
          }
          this.rows = this.$FormatMablaghGrid(list.filter((x) => x.mande > 0))
        }
      })
    },
    GetItemCardTaahodatSahebHesab() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxios_SahebHesab.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_SahebHesab)
        .then((data) => {
          this.CardItemTaahodatSahebHesab = data.filter((x) => x.tblSarfaslTypeId != 6)
          var result = this.CardItemTaahodatSahebHesab.reduce((unique, o) => {
            if (!unique.some((obj) => obj.wwwtblAzaId === o.wwwtblAzaId && obj.value === o.value)) {
              unique.push(o)
            }
            return unique
          }, [])
          this.groupBy = result
        })
        .finally(() => {
          if (this.$session.get('UserFromAccount')) {
            if (this.$session.get('UserFromAccount')[1] == true) {
              if (this.$session.get('UserFromAccount')[0] != this.$session.get('UserInfoNetPa').wwwtblAzaId) {
                document.getElementById('Logo-tab').click()
                document.getElementById(this.$session.get('UserFromAccount')[0]).click()
                this.$session.remove('UserFromAccount')
              } else {
                this.$session.remove('UserFromAccount')
              }
            }
          }
          this.loadingRender = false
        })
    },
    Deposit(Taahodat) {
      this.$router.push({
        name: 'Deposit',
        params: {
          TaahodatItem: Taahodat,
          wwwtblAzaIdAccount: Taahodat.wwwtblAzaId,
        },
      })
    },
    Payment() {
      this.$router.push({
        name: 'Debtor',
      })
    },
    debtor(row) {
      var GhebelBardasht = Number(row.ghabelBardasht.replace(/,/g, '').replace(/\./g, '')) + Number(row.sumMabTaeedNaShode.replace(/,/g, '').replace(/\./g, ''))
      this.$router.push({ name: 'Debtor', params: { TaahodatId: row.id, GhebelBardasht: GhebelBardasht } })
    },
    OpenDetail(index) {
      this.detailInModalSahebHesab = null
      this.detailInModal = index
    },
    OpenDetailSahebanHesab(index) {
      this.detailInModal = null
      this.detailInModalSahebHesab = index
    },
    GetAtach(row) {
      if (row.spName != null) {
        let Params = ''
        let QParams = row.spName.split('@')

        for (let index = 1; index < QParams.length; index++) {
          Params = Params + '@' + QParams[index]
        }
        if (Params.match('@ShmoareOzv = 0') != null) {
          Params = Params.replaceAll('@ShmoareOzv = 0', "@ShmoareOzv =' " + this.$session.get('UserInfoNetPa').shomareOzv.trim() + "'")
        }
        if (Params.match('@ShmoareOzv= 0') != null) {
          Params = Params.replaceAll('@ShmoareOzv= 0', "@ShmoareOzv =' " + this.$session.get('UserInfoNetPa').shomareOzv.trim() + "'")
        }
        if (Params.match('@ShmoareOzv=0') != null) {
          Params = Params.replaceAll('@ShmoareOzv=0', "@ShmoareOzv =' " + this.$session.get('UserInfoNetPa').shomareOzv.trim() + "'")
        }
        var DataAxios = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'InsNewVam/AatachVam',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('Params', Params)
        formData.append('Query', QParams[0])
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((data) => {
          let a = JSON.parse(data)
          this.GridDataAtachVam = a
          // console.log(a);
        })
      }
    },
    getSahamsettings() {
      var DataAxios_GetSaham = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe/GetSahamSettings',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      DataAxios_GetSaham.ArryfildValue = formData
      this.$PostFormData(DataAxios_GetSaham).then((data) => {
        this.DataAxiosSaham = data.data
        this.logo = data.logo
        this.emza1 = data.emza1
        this.emza2 = data.emza2
      })
    },
    CheckIsSaham(row) {
      return this.DataAxiosSaham.wwwtblNoeId == row.wwwtblNoeId
    },
    ShowBargeSaham(item) {
      this.$router.push({ name: 'PrintBargeSaham', params: { Data: this.DataAxiosSaham, Taahoadat: item, Image: { logo: this.logo, emza1: this.emza1, emza2: this.emza2 } } })
    },
    CalcEmtiazXasForTable(EmtizatPerson){
      let sum=0;
      EmtizatPerson.forEach((el)=>{
        if(el.Base != null){
          sum+=el.Emtiaz
        }

        
      })
      return sum
    }
  },
}
</script>
<style scoped>
.fl {
  float: left !important;
}
.bg-gray {
  background: #cecece !important;
}
.border-line {
  border-right: 1px solid #bdbdbd;
  text-align: center;
}

.costom-card {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  /* box-shadow: 0px 4px 8px 0px #435ebe; */

  margin-top: 50px;
  margin-bottom: 50px;
}

.costom-card-sahebanhesab {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  box-shadow: 0px 4px 8px 0px #95f1b4;

  margin-top: 50px;
  margin-bottom: 50px;
}

@media all and (max-width: 980px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}

.btn-secondary:hover {
  outline: none !important;
  border: solid 1px gray !important;
}
</style>
<style>
@media print {
  .no-print {
    display: none;
  }
}
</style>
